import React, { forwardRef, useCallback } from 'react';
import { Link } from 'react-router-dom';

import { isSubmitKey } from 'Lib/utils/keyboardUtils';
import useNavigate from 'Hooks/useNavigate';
import type { Shadow } from 'Types';

type Props = Shadow<
  React.ComponentProps<typeof Link>,
  {
    // disallow react-router-dom's object-based `to` prop
    to: string;
  }
>;

const SpacebarLink = forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  const { to, onClick } = props;
  const navigate = useNavigate();

  const handleKeyDown = useCallback<React.KeyboardEventHandler>(
    (e) => {
      if (isSubmitKey(e.code, false)) {
        if (onClick) {
          // we are passing keyboard event to mouse event handler (?)
          onClick(e as unknown as React.MouseEvent<HTMLAnchorElement>);
        }
        if (!e.isDefaultPrevented()) {
          navigate(to);
          e.preventDefault();
        }
        e.stopPropagation();
      }
    },
    [onClick, to, navigate]
  );

  return <Link onKeyDown={handleKeyDown} {...props} ref={ref} />;
});

export default SpacebarLink;
